<script>
    
    import { onMount, tick } from 'svelte';

    import { tweened } from 'svelte/motion';
	import { sineInOut } from 'svelte/easing';

    const viewportX = tweened(1900, {
		duration: 750,
		easing: sineInOut
	});

    const viewportY = tweened(2500, {
		duration: 750,
		easing: sineInOut
	});

    export let grid;

    let canvas;
    let zoom = 1.0;
    let totalWidth = 0;
    let totalHeight = 0;

    let wordSpacingX;
    let wordSpacingY;

    let parent;

    function handleResize() {
        let pRect = parent.getBoundingClientRect();
        canvas.width = pRect.width;
        canvas.height = pRect.height;
    }
    
    onMount(async () => {

        handleResize();

        const ctx = canvas.getContext('2d');

        let frame;

        (function loop() {

            if (!canvas) {
                return;
            }
            let width = canvas.width;
            let height = canvas.height;
            wordSpacingX = width / 4.5;
            wordSpacingY = height / 14;
            totalWidth = wordSpacingX * grid.length;
            totalHeight = wordSpacingY * grid[0].length;

            ctx.fillStyle = 'rgb(255, 255, 255)';
            ctx.fillRect(0, 0, width, height);
            
            ctx.save();
            ctx.translate(-$viewportX, -$viewportY);
            ctx.scale(zoom, zoom);

            ctx.fillStyle = 'rgb(0, 0, 0)';

            // viewport to grid coordinates
            let gridX = Math.floor($viewportX / wordSpacingX);
            let gridY = Math.floor($viewportY / wordSpacingY);

            let endX = (gridX + width / wordSpacingX) + 1;
            let endY = (gridY + height / wordSpacingY) + 2;
            let centerX = (gridX + endX) / 2;
            let centerY = (gridY + endY) / 2;

            let drawnCount = 0;
            for (let x = gridX; x < (gridX + width / wordSpacingX) + 1; x++) {
                for (let y = gridY; y < (gridY + height / wordSpacingY) + 2; y++) {
                    let blurAmt = Math.sqrt(Math.pow(x - centerX, 2) + (Math.pow(y - centerY, 2)));
                    ctx.fillStyle = `rgba(0, 0, 0, ${1 - blurAmt*0.1})`;
                    let word = grid[(grid.length + x) % grid.length][(grid[0].length + y) % grid[0].length];
                    let baseFontSize = wordSpacingX * 0.125;
                    if (word.length > 10) { // smaller as it gets longer
                        baseFontSize *= 1 - (0.1 * (word.length - 10));
                    }
                    ctx.font = baseFontSize + "px 'Space Mono'";
                    ctx.fillText(word, x * wordSpacingX, y * wordSpacingY);
                    drawnCount += 1;
                }
            }

            ctx.restore();
            frame = requestAnimationFrame(loop);

        }());

        return () => {
            cancelAnimationFrame(frame);
        };
    });

    function panViewportMouse(e) {
        e.preventDefault();
        if (e.buttons == 1) {
            viewportX.update(n => n - e.movementX, {duration: 0});
            viewportY.update(n => n - e.movementY, {duration: 0});
        }
    }

    let lastTouchX;
    let lastTouchY;

    function panViewportTouch(e) {
        if (lastTouchX && lastTouchY) {
            viewportX.update(n => n - (e.touches[0].clientX - lastTouchX), {duration: 0});
            viewportY.update(n => n - (e.touches[0].clientY - lastTouchY), {duration: 0});
        }
        lastTouchX = e.touches[0].clientX;
        lastTouchY = e.touches[0].clientY;
        e.preventDefault();
    }

    export function jump() {
        viewportX.set(Math.random()*totalWidth);
        viewportY.set(Math.random()*totalHeight);
    }

    export function jumpTo(pos) {
        viewportX.set((pos[0] * wordSpacingX) - (canvas.width / 2) + (wordSpacingX / 2));
        viewportY.set((pos[1] * wordSpacingY) - canvas.height / 2);
    }

</script>

<style>
    canvas {
        width: 100%;
        height: 100%;
    }
    #canvas-parent {
        width: 100%;
        height: 100%;
    }
</style>

<svelte:window on:resize={handleResize}></svelte:window>

<div id="canvas-parent" bind:this={parent}>
<canvas
    class="lev3"
    bind:this={canvas}
    width="640"
    height="640"
    on:mousemove={panViewportMouse}
    on:touchmove={panViewportTouch}
    on:touchend={() => { lastTouchX = undefined; lastTouchY = undefined; }}
    ></canvas>
</div>
